import { useCountry } from "./useCountry"

export function useLogisticLogic() {
    const country = useCountry();
    return {
        wholesalerLogistic: country?.countrycode !== "ES",
        directLogistic: country && ["IT", "ES"].includes(country.countrycode)
    }
}